module.exports = __webpack_public_path__ + "static/media/refresh-boards-i-padb2x.37954d39.jpg";